import Vue from "vue";
import VueRouter from "vue-router";
import home from "./home";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { checkUrl, isLogin } from "@/utils/auth";
import http from "@/utils/httpService.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "/home",
    component: () =>
      import(/* webpackChunkName: "layouts" */ "@/views/index.vue"),
    children: [...home]
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/user/login"),
    meta: {
      permissionsPath: "system"
    }
  },
  {
    path: "/findPassWord",
    name: "findPassWord",
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/user/findPassWord"),
    meta: {
      permissionsPath: "system"
    }
  },
  {
    path: "/skeleton",
    name: "skeleton",
    component: () =>
      import(/* webpackChunkName: "user" */ "@/skeleton/skeleton.vue"),
    meta: {
      permissionsPath: "system"
    }
  },
  {
    path: "/403",
    name: "403",
    component: () =>
      import(/* webpackChunkName: "exception" */ "@/views/exception/403"),
    meta: {
      permissionsPath: "system"
    }
  },
  {
    path: "*",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "exception" */ "@/views/exception/404"),
    meta: {
      permissionsPath: "system"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }

  // 把上个页面还没结束的请求取消掉,目前没有开启该功能
  http.pendingRequest.forEach(item => {
    item.routeChangeCancel && item.cancel();
  });
  if (to.path == "/findPassWord") {
    next();
  }
  if (!isLogin() && to.path !== "/login" && to.path !== "/findPassWord") {
    next({
      path: "/login"
    });
  }

  let getCheckUrl = checkUrl(to.path, to.meta.permissionsPath);

  if (
    to.path !== "/404" &&
    to.path !== "/403" &&
    (getCheckUrl == "404" || getCheckUrl == "403")
  ) {
    next({
      path: "/" + getCheckUrl
    });
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
